<script setup lang="ts">
const props = defineProps<{
  criterionValues: never
  canonicalProductId: number
}>()

const {
  criterionValues,
  canonicalProductId
} = toRefs(props)

</script>

<template>
  <div class="df fww mt-1">
    <div
        v-for="(criterionValue, index) in criterionValues"
        :key="index"
        class="fb33 pb-1 product-page__cara">
      <p class="weight--intermedium">{{ criterionValue.displayName }}</p>
      <h3>{{ criterionValue.value }}</h3>
    </div>
    <div>
      <p class="weight--intermedium">{{ $t('www.product.ref') }}</p>
      <div>CP{{ canonicalProductId }}</div>
    </div>
  </div>
</template>
